import api from 'src/shared/api/axios';
import type {
    ChangeOrderDetail,
    ChangeOrderRow,
    ChangeOrderStatus,
    ChangeOrderSummary,
} from 'src/types/changeOrder.type';

export type CreateChangeOrderInput = {
    title: string;
    description?: string | null;
    reasonCode?: string | null;

    // ✅ 미지정이면 서버가 createdByUserId로 자동 설정
    ownerUserId?: string | null;

    costDelta?: number | null;
    currency?: string | null;
    scheduleDeltaDays?: number | null;
    linkedWbsIds?: any;

    nextAction?: string | null;
    nextDueDate?: string | null; // YYYY-MM-DD
    blockedReason?: string | null;

    evidenceLinks?: any;
};

export type UpdateChangeOrderPatch = Partial<CreateChangeOrderInput> & {
    decidedAt?: string | null;
    decisionNote?: string | null;
    status?: ChangeOrderStatus;
};

export async function apiListChangeOrders(projectId: string, contractId: string): Promise<ChangeOrderRow[]> {
    const { data } = await api.get(`/projects/${projectId}/contracts/${contractId}/change-orders`);
    const v = data?.data ?? data;
    return Array.isArray(v) ? (v as ChangeOrderRow[]) : [];
}

export async function apiGetChangeOrder(
    projectId: string,
    contractId: string,
    changeOrderId: string,
): Promise<ChangeOrderDetail> {
    const { data } = await api.get(`/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}`);
    return (data?.data ?? data) as ChangeOrderDetail;
}

export async function apiGetChangeOrderSummary(projectId: string, contractId: string): Promise<ChangeOrderSummary> {
    const { data } = await api.get(`/projects/${projectId}/contracts/${contractId}/change-orders/summary`);
    return (data?.data ?? data) as ChangeOrderSummary;
}

export async function apiCreateChangeOrder(projectId: string, contractId: string, body: CreateChangeOrderInput) {
    const { data } = await api.post(`/projects/${projectId}/contracts/${contractId}/change-orders`, body);
    return data?.data ?? data;
}

export async function apiUpdateChangeOrder(
    projectId: string,
    contractId: string,
    changeOrderId: string,
    patch: UpdateChangeOrderPatch,
) {
    const { data } = await api.patch(
        `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}`,
        patch,
    );
    return data?.data ?? data;
}

export async function apiDeleteChangeOrder(projectId: string, contractId: string, changeOrderId: string) {
    const { data } = await api.delete(`/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}`);
    return data?.data ?? data;
}

export async function apiSetChangeOrderStatus(
    projectId: string,
    contractId: string,
    changeOrderId: string,
    body: {
        status: ChangeOrderStatus;
        note?: string | null;

        nextAction?: string | null;
        nextDueDate?: string | null; // YYYY-MM-DD
        blockedReason?: string | null;

        decidedAt?: string | null;
        decisionNote?: string | null;
        evidenceLinks?: any;
    },
) {
    const { data } = await api.post(
        `/projects/${projectId}/contracts/${contractId}/change-orders/${changeOrderId}/status`,
        body,
    );
    return data?.data ?? data;
}
